import { Link } from 'react-router-dom';
import { featuredEvents } from '@/mocks/sports';

export default function HotEvents() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              热门赛事
            </h2>
            <p className="text-sm text-foreground-600">精选全球顶级对决，实时赔率更新</p>
          </div>
          <Link
            to="/category/football"
            className="flex items-center gap-1.5 text-sm font-label font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部赛事
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {featuredEvents.map((event) => (
            <Link
              key={event.id}
              to={`/category/${event.categorySlug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-label font-semibold">
                    {event.tag}
                  </span>
                  <span className="text-xs text-foreground-500 font-label">{event.league}</span>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-time-line text-xs"></i>
                  </div>
                  <span>{event.time}</span>
                </div>
              </div>

              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-100 flex items-center justify-center">
                    <i className={`${event.homeLogo} text-foreground-600 text-lg`}></i>
                  </div>
                  <span className="text-base md:text-lg font-heading font-semibold text-foreground-950">
                    {event.homeTeam}
                  </span>
                </div>
                <span className="text-sm font-heading font-bold text-foreground-400 px-3">VS</span>
                <div className="flex items-center gap-3">
                  <span className="text-base md:text-lg font-heading font-semibold text-foreground-950">
                    {event.awayTeam}
                  </span>
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-100 flex items-center justify-center">
                    <i className={`${event.awayLogo} text-foreground-600 text-lg`}></i>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-background-200/70">
                <div className="flex items-center gap-4">
                  <div className="text-center">
                    <p className="text-xs text-foreground-500 mb-0.5">主胜</p>
                    <p className="text-sm font-label font-bold text-primary-500">{event.homeOdds}</p>
                  </div>
                  {event.drawOdds && (
                    <div className="text-center">
                      <p className="text-xs text-foreground-500 mb-0.5">平局</p>
                      <p className="text-sm font-label font-bold text-foreground-700">{event.drawOdds}</p>
                    </div>
                  )}
                  <div className="text-center">
                    <p className="text-xs text-foreground-500 mb-0.5">客胜</p>
                    <p className="text-sm font-label font-bold text-foreground-700">{event.awayOdds}</p>
                  </div>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-eye-line text-xs"></i>
                  </div>
                  <span>{(event.viewers / 10000).toFixed(1)}万关注</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}